import { data } from "browserslist";
import API from "../../../global/api";
//Action types
export const LOGIN_ADMIN_SUCCESS = "LOGIN_ADMIN_SUCCESS";
export const LOGIN_ADMIN_ERROR = "LOGIN_ADMIN_ERROR";

// Request Actions

const loginAdminSuccess = (data) => ({
  type: LOGIN_ADMIN_SUCCESS,
  payload: data,
});

export const loginAdminError = () => ({
  type: LOGIN_ADMIN_ERROR,
});

//Api calls
export const getLogin = (username, password) => {
  return (dispatch) => {
    API.post(`/admin/admin-login`, {
      email: username,
      password: password,
    })
      .then((res) => {
        

        window.localStorage.setItem("isAuthenticated", true);
        window.localStorage.setItem("isAdmin", true);
        window.localStorage.setItem("user_id", `${res.data.admin_user_id}`);
        window.location.replace("/");

        dispatch(loginAdminSuccess(res.data));
      })
      .catch((error) => {
        dispatch(loginAdminError())
      });
  };
};
